import * as React from "react";
import Vadis from "services/vadisKontrollrapportService";
import Innlogging from "pages/Innlogging";
import Kontrollrapportvisning from "pages/Kontrollrapportvisning";
import Utlogget from "pages/Utlogget";
import {useQuery} from "utils/hooks";
import {useContext, useEffect} from "react";
import {DispatchContext, StateContext} from "App";
import {useApptekster} from "../contexts/ApptekstContext";
import {SVVSpinner} from "@komponentkassen/svv-spinner";

function Sidevisning() {
    const state = useContext(StateContext);
    const dispatch = useContext(DispatchContext);
    const t = useApptekster();
    const queryparametre = useQuery();

    const sesjonErUtlopt = queryparametre.has("session-expired");

    useEffect(() => {
        if (sesjonErUtlopt) {
            dispatch({type: "LOGG_UT"});
        } else {
            Vadis.hentKontrollrapport().then(kontrollrapport => {
                dispatch({type: "VIS_LASTET_KONTROLLRAPPORT", value: kontrollrapport});
            }).catch(() => {
                dispatch({type: "VIS_INNLOGGING"});
            })
        }
    }, [dispatch, sesjonErUtlopt]);

    function visInnhold() {
        switch (state.name) {
            case "SJEKKER_OM_LOGGET_INN":
                return <SVVSpinner size="medium" centered={true} inline={false}>{t("vadis-kontrollrapport-app.sjekker-om-innlogget")}</SVVSpinner>;
            case "VISER_INNLOGGINGSSKJEMA":
                return <Innlogging skjemaState={state.innloggingsskjema}/>;
            case "VISER_UTLOGGET_SIDE":
                return <Utlogget/>;
            case "VISER_LASTET_KONTROLLRAPPORT":
                return <Kontrollrapportvisning kontrollrapport={state.kontrollrapport}/>;
        }
    }

    return (
        <div className="App">
            {visInnhold()}
        </div>
    )
}

export default Sidevisning;
